module.exports = __webpack_public_path__ + "img/5-3.f042f4e0.png";